export const enum StickerType {
    /** an official sticker in a pack */
    STANDARD = 1,
    /** a sticker uploaded to a guild for the guild's members */
    GUILD = 2
}

export const enum StickerFormatType {
    PNG = 1,
    APNG = 2,
    LOTTIE = 3,
    GIF = 4
}
